import {contentFeedsApi} from 'common/src/modules/contentFeeds/contentFeeds.api';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {CampaignSetupAgentToolName} from '../../campaignSetupAgent.enums';

// Tool schema
const getContentFeedsToolSchema = z.object({
  prompt: z
    .string()
    .describe('Detailed description of the content feed to search for following the user prompt.'),
});

const MAX_CONTENT_FEEDS_COUNT = 10;

function getContentFeedsTool() {
  async function execute({
    input: {prompt},
  }: ToolExecuteParams<typeof getContentFeedsToolSchema>): Promise<ToolResult> {
    try {
      // Get all feeds
      const searchResponse = await contentFeedsApi.searchFeeds(prompt);

      if (!searchResponse.contentFeeds.length) {
        return toolResult(`No content feeds found. Reason: ${searchResponse.filtersExplanation}`);
      }

      const contentFeeds = searchResponse.contentFeeds.slice(0, MAX_CONTENT_FEEDS_COUNT);

      return toolResult(
        JSON.stringify({
          contentFeeds: contentFeeds.map((feed) => ({
            id: feed.id,
            name: feed.name,
          })),
          instructions:
            contentFeeds.length > 1
              ? `More than one content feed found, use the first content feed and ask the user for clarification.`
              : '',
        }),
      );
    } catch (error) {
      return toolResult(
        `Error retrieving content feeds: ${
          error instanceof Error ? error.message : 'Unknown error'
        }`,
      );
    }
  }

  return tool({
    name: CampaignSetupAgentToolName.GetContentFeeds,
    displayName: 'Searching content feeds',
    description: "Search for feeds from account's content feeds library based on a prompt.",
    execute,
    inputSchema: getContentFeedsToolSchema,
  });
}

export default getContentFeedsTool;
